import { get } from 'lodash/fp';
import { IHelpArticleListsResponse, HelpArticalListsPageType } from '../helpers/types';

import { mergeReplaceArrays } from '../helpers/objects';
import { getHelpArticle, resetHelpPageError, getHelpArticleListsContent } from '../actions/help';

interface IState {
  data: {
    [locale: string]: {
      partners: IHelpArticleListsResponse;
      categories: IHelpArticleListsResponse;
    };
  };
  loading: boolean;
  error: null | Error;
}

const initialState: IState = {
  data: {},
  loading: false,
  error: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case resetHelpPageError.TRIGGER:
      return { ...state, error: null };

    case getHelpArticle.REQUEST:
    case getHelpArticleListsContent.REQUEST:
      return { ...state, loading: true, error: null };

    case getHelpArticle.SUCCESS: {
      const { locale, articles } = action.payload;
      const prevArticles = get(`data.${locale}.articles`, state);
      return {
        ...state,
        data: {
          ...state.data,
          [locale]: {
            articles: mergeReplaceArrays(prevArticles, articles),
          },
        },
      };
    }

    case getHelpArticleListsContent.SUCCESS: {
      const { locale, helpType, slug, response } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [locale]: {
            ...state.data[locale],
            [helpType as HelpArticalListsPageType]: {
              ...state.data[locale]?.[helpType as HelpArticalListsPageType],
              [slug]: response,
            },
          },
        },
      };
    }

    case getHelpArticleListsContent.FAILURE:
    case getHelpArticle.FAILURE:
      return { ...state, error: action.payload };

    case getHelpArticleListsContent.FULFILL:
    case getHelpArticle.FULFILL:
      return { ...state, loading: false };

    default:
      return state;
  }
};
